import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { PortalBaseService } from '../portal-base.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { StringIgnoreCaseComparator } from 'src/app/shared/utils/comparators';
import { lastValueFrom, Observable } from 'rxjs';
import { ISharedAttributeService } from 'src/shared-app-portal/interfaces/i-shared-attribute-service';

@Injectable({
  providedIn: 'root'
})
export class PortalAttributeService extends PortalBaseService implements ISharedAttributeService {
  constructor() {
    super();
  }

  getAttributeDefinitions = (): Promise<AttributeDefinition[]> =>
    lastValueFrom(
      this.get<AttributeDefinition[]>('portal/definitions/custom-fields').pipe(
        map((data) =>
          data
            .filter((attrType) => !attrType.isArchived)
            .map((attrType) => AttributeDefinition.parse(attrType))
            .sort(StringIgnoreCaseComparator('name'))
        )
      )
    );

  decryptAttribute(attributeDefinitionId: string, encryptedValue: string): Observable<any> {
    let path = `portal/definitions/custom-fields/${attributeDefinitionId}/decrypt/${encryptedValue}`;
    return this.put(path);
  }
}
